class BaseApi {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL;
  }
}

export default BaseApi;



// WEBPACK FOOTER //
// ./src/services/api/base-api.js